// extracted by mini-css-extract-plugin
export default {"formInput":"FormInput_formInput__Cy0JV","formInputLabel":"FormInput_formInputLabel__pRjT8","required":"FormInput_required__stkxG","textarea":"FormInput_textarea__MbotD"};